// action - customization reducer
export const SET_MENU = '@customization/SET_MENU';
export const MENU_TOGGLE = '@customization/MENU_TOGGLE';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';

// action - contact reducer
export const CONTACT = '@contact/CONTACT';

// action - download reducer
export const DOWNLOAD = '@download/DOWNLOAD';

// action - help reducer
export const HELP = '@help/HELP';

// action - home reducer
export const HOME = '@home/HOME';

// action - multiomics/exprisson reducer
export const MULTI_OMICS_EXPRESSION = '@multiomics/exprisson/EXPRESSION';

// action - multiomics/transcripts reducer
export const MULTI_OMICS_TRANSCRIPTS = '@multiomics/transcripts/TRANSCRIPTS';

// action - multiomics/variation reducer
export const MULTI_OMICS_VARIATION = '@multiomics/variation/VARIATION';

// action - search reducer
export const GET_SEARCH_BY_ID_FROM_SERVER = '@search/GET_SEARCH_BY_ID_FROM_SERVER';
export const GET_SEARCH_BY_SEQUENCE_FROM_SERVER = '@search/GET_SEARCH_BY_SEQUENCE_FROM_SERVER';
export const SEARCH_BY_EXPRESSION_API_SET = '@search/SEARCH_BY_EXPRESSION_API_SET';
export const SEARCH_BY_EXPRESSION_QUERY_GROUP_SET = '@search/SEARCH_BY_EXPRESSION_QUERY_GROUP_SET';
export const SEARCH_BY_EXPRESSION_QUERY_RANGE_START_SET = '@search/SEARCH_BY_EXPRESSION_QUERY_RANGE_START_SET';
export const SEARCH_BY_EXPRESSION_QUERY_RANGE_END_SET = '@search/SEARCH_BY_EXPRESSION_QUERY_RANGE_END_SET';
export const SEARCH_BY_EXPRESSION_QUERY_PAGE_CURRENT_SET = '@search/SEARCH_BY_EXPRESSION_QUERY_PAGE_CURRENT_SET';
export const SEARCH_BY_EXPRESSION_QUERY_PAGE_TOTAL_SET = '@search/SEARCH_BY_EXPRESSION_QUERY_PAGE_TOTAL_SET';
export const RESET_SEARCH_BY_EXPRESSION = '@search/RESET_SEARCH_BY_EXPRESSION';

export const SEARCH_BY_SEQUENCE_API_SET = '@search/SEARCH_BY_SEQUENCE_API_SET';
export const SEARCH_BY_SEQUENCE_QUERY_SEQUENCE = '@search/SEARCH_BY_SEQUENCE_QUERY_SEQUENCE';
export const SEARCH_BY_SEQUENCE_QUERY_EVALUE = '@search/SEARCH_BY_SEQUENCE_QUERY_EVALUE';
export const SEARCH_BY_SEQUENCE_QUERY_WORD_SIZE = '@search/SEARCH_BY_SEQUENCE_QUERY_WORD_SIZE';
export const SEARCH_BY_SEQUENCE_QUERY_SEARCH_SENSIVITY = '@search/SEARCH_BY_SEQUENCE_QUERY_SEARCH_SENSIVITY';
export const SEARCH_BY_SEQUENCE_QUERY_PAGE_CURRENT = '@search/SEARCH_BY_SEQUENCE_QUERY_PAGE_CURRENT';
export const SEARCH_BY_SEQUENCE_CAN_SENDED = '@search/SEARCH_BY_SEQUENCE_CAN_SENDED';
export const SEARCH_BY_SEQUENCE_QUERY_PAGE_TOTAL = '@search/SEARCH_BY_SEQUENCE_QUERY_PAGE_TOTAL';
export const RESET_SEARCH_BY_SEQUENCE = '@search/RESET_SEARCH_BY_SEQUENCE';

export const GET_SEARCH_BY_GENOME_LOCATION_AND_OTHER_MOLECULAR_FEATURES_FROM_SERVER =
    '@search/GET_SEARCH_BY_GENOME_LOCATION_AND_OTHER_MOLECULAR_FEATURES_FROM_SERVER';
export const SET_SEARCH_BY_ID = '@search/SET_SEARCH_BY_ID';
export const SET_SEARCH_BY_EXPRESSION = '@search/SET_SEARCH_BY_EXPRESSION';
export const SET_SEARCH_BY_GENOME_LOCATION_AND_OTHER_MOLECULAR_FEATURES =
    '@search/SET_SEARCH_BY_GENOME_LOCATION_AND_OTHER_MOLECULAR_FEATURES';

// action - statistics reducer
export const STATISTICS = '@statistics/STATISTICS';

// action - submit reducer
export const SUBMIT = '@submit/SUBMIT';

// action - transcripts reducer
export const CAN_TRANSCRIPTS_RENDER = '@transcripts/CAN_TRANSCRIPTS_RENDER';
export const CAN_TRANSCRIPTS_TABLE_RENDER = '@transcripts/CAN_TRANSCRIPTS_TABLE_RENDER';
export const SET_TRANSCRIPTS_TABLES_DATA = '@transcripts/TRANSCRIPTS_TABLES_DATA';
export const SET_TRANSCRIPTS_SEARCH = '@transcripts/TRANSCRIPTS_SEARCH';
export const SET_TRANSCRIPTS_ADVANCED_SEARCH_TO_SHOW = '@transcripts/SET_TRANSCRIPTS_ADVANCED_SEARCH_TO_SHOW';
export const SET_TRANSCRIPTS_TABLE_TO_SHOW = '@transcripts/SET_TRANSCRIPTS_TABLE_TO_SHOW';
export const SET_FORMAT_TRANSCRIPTS_TABLE_TO_DOWNLOAD = '@transcripts/SET_FORMAT_TRANSCRIPTS_TABLE_TO_DOWNLOAD';
export const SET_DATA_TRANSCRIPTS_TABLE_TO_DOWNLOAD = '@transcripts/SET_DATA_TRANSCRIPTS_TABLE_TO_DOWNLOAD';
export const SET_TRANSCRIPT_ID = '@transcripts/SET_TRANSCRIPT_ID';
export const TRANSCRIPT_SEARCH_SET_PATH = '@transcripts/TRANSCRIPT_SEARCH_SET_PATH';
export const TRANSCRIPT_SEARCH_QUERY_SET_NUMBER_OF_ROWS_PER_PAGE_TO_SHOW =
    '@transcripts/TRANSCRIPT_SEARCH_QUERY_SET_NUMBER_OF_ROWS_PER_PAGE_TO_SHOW';
export const TRANSCRIPT_SEARCH_QUERY_SET_GENE_ID = '@transcripts/TRANSCRIPT_SEARCH_QUERY_SET_GENE_ID';
export const TRANSCRIPT_SEARCH_QUERY_SET_TRANSCRIPT_ID = '@transcripts/TRANSCRIPT_SEARCH_QUERY_SET_TRANSCRIPT_ID';
export const TRANSCRIPT_SEARCH_QUERY_SET_CLASSIFICATION = '@transcripts/TRANSCRIPT_SEARCH_QUERY_SET_CLASSIFICATION';
export const TRANSCRIPT_SEARCH_QUERY_SET_LOCATION = '@transcripts/TRANSCRIPT_SEARCH_QUERY_SET_LOCATION';
export const TRANSCRIPT_SEARCH_QUERY_SET_LENGTH = '@transcripts/TRANSCRIPT_SEARCH_QUERY_SET_LENGTH';
export const TRANSCRIPT_SEARCH_QUERY_SET_EXON = '@transcripts/TRANSCRIPT_SEARCH_QUERY_SET_EXON';
export const TRANSCRIPT_SEARCH_QUERY_SET_PAGE = '@transcripts/TRANSCRIPT_SEARCH_QUERY_SET_PAGE';
export const RESET_TRANSCRIPT_SEARCH_QUERY = '@transcripts/RESET_TRANSCRIPT_SEARCH_QUERY';
export const CHANGE_TABLE_PAGINATION_PAGE = '@transcripts/CHANGE_TABLE_PAGINATION_PAGE';
export const CONTENT_SET_CSV_TABLE_DATA = '@transcripts/CONTENT_SET_CSV_TABLE_DATA';
export const CAN_CONTENT_CSV_TABLE_RENDER = '@transcripts/CAN_CONTENT_CSV_TABLE_RENDER';
export const CONTENT_SET_GTF_TABLE_DATA = '@transcripts/CONTENT_SET_GTF_TABLE_DATA';
export const CAN_CONTENT_GTF_TABLE_RENDER = '@transcripts/CAN_CONTENT_GTF_TABLE_RENDER';
export const CONTENT_SET_SEQUENCE = '@transcripts/CONTENT_SET_SEQUENCE';
export const CONTENT_SET_CHEMICAL_CHART_DATA = '@transcripts/CONTENT_SET_CHEMICAL_CHART_DATA';
export const RESET_TRANSCRIPT_CONTENT_CHARTS_STATES = '@transcripts/RESET_TRANSCRIPT_CONTENT_CHARTS_STATES';
export const RESET_TRANSCRIPT_STATES = '@transcripts/RESET_TRANSCRIPT_STATES';

// action - smallRnaTarget
export const SET_SMALLRNA_TABLES_DATA = '@smallRnaTarget/SMALLRNA_TABLES_DATA';
export const CAN_SMALLRNA_RENDER = '@smallRnaTarget/CAN_SMALLRNA_RENDER';
export const RESET_SMALLRNA_STATES = '@smallRnaTarget/RESET_SMALLRNA_STATES';
export const SET_DATA_SMALLRNA_TABLE_TO_DOWNLOAD = '@smallRnaTarget/SET_DATA_SMALLRNA_TABLE_TO_DOWNLOAD';
export const SMALLRNA_SEARCH_QUERY_SET_PAGE = '@smallRnaTarget/SMALLRNA_SEARCH_QUERY_SET_PAGE';
export const SMALLRNA_SEARCH_SET_PATH = '@smallRnaTarget/SMALLRNA_SEARCH_SET_PATH';
